import React, { FC, PropsWithChildren, useState } from 'react';
import { useParams } from 'react-router-dom';

import { Icon } from '@column/column-ui-kit';
import { Button } from '@column/ui';

import { CustomPageContext, PageTabs } from '~/app/Layout';
import { PageActions } from '~/app/Layout/PageFrameContext';
import { ROUTE } from '~/app/routes';
import { ModalCreateStatement } from '~/components/Dialog';
import { StatementsTable } from '~/components/StatementsTable';
import { DAILY_STATEMENT_TYPE, MONTHLY_STATEMENT_TYPE } from '~/components/StatementTableColumns';
import { FeatureFlag, useFeatureFlag } from '~/lib/flags';
import { useNavigate } from '~/lib/navigation';

const PageStatements: FC<{ statementType: string }> = ({ statementType }) => {
  const navigate = useNavigate();
  const isDaily = statementType === DAILY_STATEMENT_TYPE;

  return (
    <StatementsTable
      tableId="statements"
      className="pt-3"
      filter={{ category: 'statement' }}
      empty={{
        icon: <Icon.AnimationDocument />,
        title: 'No statements found',
      }}
      statementType={statementType}
      hideAccountFilter={isDaily}
      onRowClick={(entry) => navigate(`${ROUTE.STATEMENTS}/${isDaily ? 'daily/' : ''}${entry.id}`)}
      hideAccount={isDaily}
      exactDateFilter={isDaily}
    />
  );
};

export const PageMonthlyStatements: FC = () => <PageStatements statementType={MONTHLY_STATEMENT_TYPE} />;

export const PageDailyStatements: FC = () => <PageStatements statementType={DAILY_STATEMENT_TYPE} />;

export const PageStatementsSection: FC<PropsWithChildren<CustomPageContext>> = ({ entries, children }) => {
  const { id } = useParams();
  const [isCreateStatementOpen, setIsCreateStatementOpen] = useState(false);
  const enableCustomCSVStatements = useFeatureFlag(FeatureFlag.EnableCustomCSVStatements);

  return (
    <>
      {!id && <PageTabs entries={entries} />}
      {!id && enableCustomCSVStatements && (
        <PageActions>
          <Button type="button" size="sm" variant="secondary" onClick={() => setIsCreateStatementOpen(true)}>
            <Icon.AnimationDownload />
            Export Custom CSV
          </Button>
        </PageActions>
      )}
      {children}
      <ModalCreateStatement isOpen={isCreateStatementOpen} onClose={() => setIsCreateStatementOpen(false)} />
    </>
  );
};
